import(/* webpackMode: "eager" */ "/app/app/blogs/page.tsx");
